import { Pagination, styled } from '@mui/material'
import React from 'react'

const TablePagination = ({
  dataLength,
  rowsPerPage,
  page,
  setPage,
  sx,
}: {
  dataLength: number
  rowsPerPage: number
  page: number
  setPage: any
  sx?: any
}) => {
  const StyledPagination = styled(Pagination)(({ theme }) => ({
    '& .MuiPagination-ul': {
      justifyContent: 'center', // Center the pagination items
      width: '100%', // Ensure full width
    },
    '& .MuiButtonBase-root': {
      color: 'white',
      minWidth: '28px',
      height: '28px',
      padding: '0 4px',
      fontSize: '0.75rem',
    },
    '& .MuiPaginationItem-root': {
      color: 'white',
      margin: '0 2px',
      padding: '0 4px',
      border: '1px solid rgba(255, 255, 255, 0.2)',
      '&:hover': {
        backgroundColor: 'rgba(115, 246, 255, 0.1)',
      }
    },
    '& .MuiPaginationItem-root.Mui-selected': {
      color: '#73F6FF',
      borderColor: '#73F6FF',
      backgroundColor: 'rgba(115, 246, 255, 0.05)',
      '&:hover': {
        backgroundColor: 'rgba(115, 246, 255, 0.15)',
      }
    },
    '@media (max-width: 600px)': {
      '& .MuiPaginationItem-page:not(.Mui-selected)': {
        display: 'none',
        '&:nth-of-type(2), &:nth-last-of-type(2)': {
          display: 'inline-flex',
        }
      }
    }
  }))

  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    newPage: number
  ) => {
    setPage(newPage || 1)
  }

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      width: '100%',
      height: '100%',
      alignItems: 'center'
    }}>
      <StyledPagination
        count={Math.ceil(dataLength / rowsPerPage)}
        page={page}
        onChange={handleChangePage}
        variant="outlined"
        size="small"
        siblingCount={1}
        boundaryCount={1}
        sx={{
          ...sx,
          '& .MuiPagination-ul': {
            gap: '2px',
          }
        }}
      />
    </div>
  )
}

export default TablePagination